module.exports = __webpack_public_path__ + "images/huiskesf24f38fac3fd10a612b0648812004456.png";